"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  PricingPlans,
  usePricingPlans,
} from "@/components/landing/pricing-plans";

export function FeaturePricingSection({ slug }) {
  const plans = usePricingPlans();

  if (plans.length === 0) return null;

  return (
    <section className="bg-[#efecea] py-20 sm:py-24">
      <div className="flex flex-col items-center gap-4 px-4 pb-14 text-center">
        <Badge
          variant="outline"
          className="text-md h-7 w-fit border-0 bg-white px-3 py-2 leading-5 font-normal"
        >
          Pricing
        </Badge>
        <h2 className="text-foreground max-w-lg text-3xl font-medium sm:text-5xl">
          Pick the plan that fits your business
        </h2>
      </div>
      <div className="mx-auto max-w-7xl">
        <PricingPlans plans={plans} location={`feature_${slug}`} compact />
      </div>
      <div className="mt-8 flex justify-center px-4">
        <Link
          href="/pricing"
          className="inline-flex items-center gap-2 font-medium text-neutral-900 underline-offset-4 hover:underline"
        >
          Compare all plans
          <ArrowRight className="size-4" />
        </Link>
      </div>
    </section>
  );
}
